$(function () {
   $('.mrk-slideshow').each(function(){
     var speed = $(this).attr('data-speed');
     var autoplay = JSON.parse($(this).attr('data-autoplay'));
     $(this).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed : 1500,
        arrows: false,
        dots: false,
        autoplay: autoplay,
        fade: true,
        autoplaySpeed: speed
    });
   })
})